export default __webpack_public_path__ + "static/media/GQ.61c49d8e.svg";